import axios from 'axios';
import { takeEvery, call, put } from 'redux-saga/effects';
// redux-utils
import { adminTypes } from 'redux-utils/types/index';
import { actionTypeFormatter } from 'redux-utils/sagas/index';
// api helpers
import { get, post, endpoints } from 'api/index';

let cancelSource;

/**
 * @name appWatcherSaga
 * @description Watches for the action dispatched of certain type.
 */
const watcherSaga = [
  takeEvery(adminTypes.getSubPanel.request, getWorkerSaga),
  takeEvery(adminTypes.getSubPanelPageData.request, getWorkerSaga),
  takeEvery(adminTypes.getStickerValues.request, getWorkerSaga),
  takeEvery(adminTypes.getDisplayValues.request, getWorkerSaga),
  takeEvery(adminTypes.postSubPanelPageData.request, getWorkerSaga),
  takeEvery(adminTypes.downloadAllTemplates.request, getWorkerSaga),
  takeEvery(adminTypes.downloadTemplate.request, getWorkerSaga),
  takeEvery(adminTypes.downloadExcel.request, getWorkerSaga),
  takeEvery(adminTypes.downloadPackshots.request, getWorkerSaga),
  takeEvery(adminTypes.routeChange, getWorkerSaga)
];

function getWorkerSaga(action) {
  switch (action.type) {
    case adminTypes.getSubPanel.request: {
      return apiWorkerSaga(action, {
        uriPath: endpoints.getSubPanel,
        method: get,
        headers: ['auth']
      });
    }
    case adminTypes.getSubPanelPageData.request: {
      cancelSource = axios.CancelToken.source();
      return apiWorkerSaga(action, {
        uriPath: endpoints.getSubPanelPageData,
        method: get,
        headers: ['auth'],
        cancelToken: cancelSource.token
      });
    }
    case adminTypes.routeChange: {
      cancelSource.cancel();
      return 0;
    }
    case adminTypes.getStickerValues.request: {
      return apiWorkerSaga(action, {
        uriPath: endpoints.getStickerValues,
        method: get,
        headers: ['auth']
      });
    }
    case adminTypes.getDisplayValues.request: {
      return apiWorkerSaga(action, {
        uriPath: endpoints.getDisplayValues,
        method: get,
        headers: ['auth']
      });
    }
    case adminTypes.postSubPanelPageData.request: {
      return apiWorkerSaga(action, {
        uriPath: `${endpoints.getSubPanelPageData}?subpanel=${action.payload.other.subpanel}`,
        method: post,
        headers: ['auth']
      });
    }
    case adminTypes.downloadAllTemplates.request: {
      return apiWorkerSaga(action, {
        uriPath: endpoints.downloadAllTemplates,
        method: get,
        headers: ['auth']
      });
    }
    case adminTypes.downloadTemplate.request: {
      return apiWorkerSaga(action, {
        uriPath: endpoints.downloadTemplate,
        method: get,
        headers: ['auth']
      });
    }
    case adminTypes.downloadExcel.request: {
      return apiWorkerSaga(action, {
        uriPath: endpoints.downloadExcel,
        method: get,
        headers: ['auth']
      });
    }
    case adminTypes.downloadPackshots.request: {
      return apiWorkerSaga(action, {
        uriPath: endpoints.downloadPackshots,
        method: get,
        headers: ['auth']
      });
    }
    default:
      return null;
  }
}

/**
 * @description Get layout worker saga
 * @param {object} action - dispatched action
 * @param {object} params - api params
 * @returns {undefined}
 * @yields put - get layout success/error action.
 */
function* apiWorkerSaga(action, params) {
  try {
    const { response, error, request } = yield call(params.method, {
      payload: action.payload.params,
      useCachedInstance: false,
      ...params
    });
    if (response) {
      yield put({
        meta: action.meta,
        type: actionTypeFormatter(action.type, 'SUCCESS'),
        payload: {
          ...action.payload,
          error: null,
          request,
          response: response.data
        }
      });
    } else {
      yield put({
        meta: action.meta,
        type: actionTypeFormatter(action.type, 'FAILURE'),
        payload: {
          ...action.payload,
          error: error.data,
          request,
          response: null
        }
      });
    }
  } catch (error) {
    yield put({
      meta: action.meta,
      type: 'SAGA_ERROR',
      payload: {
        type: action.type,
        ...action.payload,
        error
      }
    });
  }
}

export default watcherSaga;
